import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ownership-icon',
  templateUrl: './ownership-icon.component.html',
  styles: []
})
export class OwnershipIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
